module.exports = __webpack_public_path__ + "media/src/img/payment/ap-d57df34889cacf309cee6292000f69a4.png";